module.exports = __webpack_public_path__ + "img/academy_team_dev.e17e844d.png";